export const getDebugLinksData = () => {
  return fetch("/debugLinks.json").then((response) => {
    const debugLinksData = response.json();
    return debugLinksData;
  });
};
